export default __webpack_public_path__ + "static/media/1.00783587.mov";